import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BuildChildren from 'utils/BuildChildren';
import classes from './CardListB.module.scss';

const CardListB = (props) => {
  const {
    items = [],
  } = props;

  return (
    items.length > 0 &&
    <div className={classes.container}>
      <h2 className={classes.title}>Industry Insights</h2>
      <div className='row'>
        {items.map((item, i) => (
          <div
            className={classNames(classes.item, 'col-md-4')}
            key={`${item}-item-${i}`}
          >
            {BuildChildren(item)}
          </div>
        ))}
      </div>
    </div>
  );
};

CardListB.propTypes = {
  items: PropTypes.array,
};

export default CardListB;
